import { useEffect, useState } from "react";
import { _Entailment, _single } from "../../../../core/services/dataBean/EntityCatalog";
import useDataBean from "../../../../core/services/dataBean/useDataBean";
import { BasicPage } from "../../../theme/Component/BasicPage";
import { BasicTable, MASK_BOOLEAN_ICON, MASK_DATE, MASK_NUMBER } from "../../../theme/Component/BasicTable";
import { Singleton } from '../../../../core/services/Singleton';
import { toast } from "react-toastify";
import usePaginator from "../../../theme/Component/usePaginator";
import { YearSelector } from "../../../../core/shared/inputs/YearSelector";
import { MonthConstantsEditor } from "../../../RemoteAbstractAction/editors/MonthConstantsEditor";
import { SelectTypeProcees } from "../../../Talentohumano/GestionTH/PaymentAccount/SelectTypeProcees";
import { CustomProcessTypeSeleect } from "../CustomProcessType/CustomProcessTypeSeleect";
import { AccountEditor } from "../../../editor/AccountEditor";
import { EstadoProcesoSelector } from "./EstadoProcesoSelector";
import { _createProcess, _fireEcmDocument } from "../../../../core/services/dataBean/EntityCatalogVdos";
import { BasicButton } from "../../../theme/Component/BasicButton";
import useModal, { MODAL_md, MODAL_XL } from "../../../theme/Component/hooks/useModal";
import { Modal } from "../../../theme/Component/Modal";
import { ListMenu } from "../../../theme/Component/ListMenu";
import { SingPanelEditor } from "../../../contabilidad/SignAndApprovalPanel/SingPanelEditor";
import { ReporteProcesosByProcces } from "../../../contract/etapa-contrato/contrac/ublinvoice/ReporteProcesosByProcces";
import { DocumentViewer } from "../../../theme/Component/DocumentViewer";
import { BasicSwitch } from "../../../theme/Component/BasicSwitch";
import { SelectSubProcessType } from "./SelectSubProcessType/SelectSubProcessType";
import { PaymentHeaderError } from "../../../contract/etapa-contrato/contrac/ublinvoice/PaymentHeaderError";
import { PrintJson } from "../../../theme/Component/PrintJson";
import { PaymentAccountByProcces } from "./PaymentAccountByProcces/PaymentAccountByProcces";

interface Props {
    idSelector?: number;
    processType?: number;
    onChange?: any;
    label?: string;
    returnType?: "ID" | "Object";
}

export const AdminProcess = ({ idSelector, processType, onChange, label, returnType }: Props) => {

    const process = useDataBean(_createProcess);
    const fireEcm = useDataBean(_fireEcmDocument);
    const paginador = usePaginator();
    const single = Singleton.getInstance();

    // const [processType, setProcessType] = useState<any>(null);
    // const [customProcces, setCustomProcces] = useState<any>(null);

    const [registers, setRegisters] = useState<number>(15);
    const [isOpen, setIsOpen] = useState<boolean>(false);
    const [lista, setLista] = useState<any>([]);
    const [ver, setVer] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [flujo, setFlujo] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [reporte, setReporte] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modal, setModal] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modalC, setModalC] = useState<any>({ name: "Eliminar", tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-sm' });
    const [modalcuentas, setModalcuentas] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modalEdit, setModalEdit] = useState<any>({ name: "Editar", tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-md' });
    const [listDoc, setListDoc] = useState<any>([]);
    const [form, setForm] = useState<any>({

        Year: _single.getCurrenYear(),
        fromMonth: _single.getCurrentMonth(),
        uptoMonth: _single.getCurrentMonth(),
        processType: processType,
        customProcces: NaN,
        IDAccount: undefined,
        state: 2
    })

    const modalNovedad = useModal("Novedades", MODAL_XL);
    const modalComponent = useModal(label ?? 'Catalogo de procesos', MODAL_XL);
    const modalDocs = useModal("Documentos adjuntos", MODAL_md);

    useEffect(() => {
        getLista();
    }, [paginador.page])



    const getLista = () => {

        process.instance.getProcessCatalog(form.processType, form.Year, null, form.fromMonth, form.uptoMonth, form.customProcces, form.state, form.IDAccount, paginador.page, registers).then(
            (resp: any) => {
                if (resp) {

                    paginador.setPages(resp.NumberOfPages);
                    paginador.setRecords(resp.NumberOfPages * (registers));
                    paginador.setRegiPerPage(registers)

                    if (resp.List) {
                        resp.List.forEach(Procesos => {
                            const proceso = Procesos.DataBeanProperties;

                            const responseJson = proceso.ResponseJsonStr ? JSON.parse(proceso.ResponseJsonStr) : "N/P"

                            proceso.EntityFuncionario = `${proceso.IDAccountProcess ?? " "} - ${proceso.AccountProcessName ?? " "}`
                            proceso.EntityEmpleado = `${proceso.IDAccount ?? " "} - ${proceso.AccountName ?? " "}`
                            proceso.RenderResponseJson = proceso.ResponseJsonStr ? true : false;
                            proceso.RenderResponseJsonData = responseJson;
                        });
                    }

                    setLista(resp.List)
                }
            }
        )

    }

    const editaItem = () => {
        //console.log(entailment.bean);
        process.update().then(
            (resp: any) => {
                getLista();
                setModal({ ...modal, "view": false });
                setModalEdit({ ...modalEdit, "view": false });
            }
        ).catch(err => {
            toast.error(err);
        })

    }

    const listaBotones = () => {
        const botones = [

            { titulo: 'Generar Flujo de Aprobación', icono: 'ri-file-transfer-line', visible: single.canEdit() && onChange ? false : true, evento: () => { setFlujo({ ...flujo, "name": ``, "view": true }) } },
            { titulo: 'Ver Flujo de Aprobación del Proceso', icono: ' ri-file-search-line', visible: single.canEdit() && onChange ? false : true, evento: () => { setVer({ ...ver, "name": ``, "view": true }) } },
            { titulo: 'Generar Reporte del Proceso', icono: 'ri-file-download-line', visible: single.canDelete() && onChange ? false : true, evento: () => { setReporte({ ...reporte, "view": true }) } },
            { titulo: 'Cuentas por Pagar', icono: 'ri-secure-payment-fill', visible: single.canEdit(), evento: () => { setModalcuentas({ ...modalcuentas, "view": true }) } },
            { titulo: 'Reporte Novedades', icono: 'ri-file-damage-line', visible: true, evento: () => { modalNovedad.open(); setIsOpen(true); } },
            { titulo: 'Editar', icono: 'ri-edit-2-fill', visible: true, evento: () => { setModalEdit({ ...modalEdit, view: true }) } },
            { titulo: 'Ver Documentos', icono: 'ri-folder-zip-line', visible: process.bean.RenderResponseJson, evento: () => { modalDocs.open() } },

        ]
        return (
            <ListMenu listaBotones={botones} />
        )
    }
    const fireEcmDocumentForFlowControl = () => {
        fireEcm.instance.fireEcmDocumentForFlowControl(fireEcm.bean.IDSignAndApprovalPanel, process.bean.IDProcess, process.bean.Since, _single.getAccountID()).then(
            (resp: any) => {
                if (resp) {

                    console.log(resp)
                    setListDoc(resp.DocumentURL);
                    setFlujo({ ...flujo, "view": false });
                }
            }
        ).catch(err => {
            toast.error(err);
        })

    }

    const updateFather = () => {
        if (onChange && process.bean.IDProcess > 0) {
            onChange(process.bean);
            modalComponent.close();
        }
        else {
            toast.warning("No ha seleccionado un valor valido");
        }
    }

    const head = [
        { title: 'ID Proceso', property: 'IDProcess', visible: true, mask: MASK_NUMBER },
        { title: 'Funcionario Ejecuta', property: 'EntityFuncionario', visible: true, },
        { title: 'Generar', property: 'isValid', visible: true },
        { title: 'Nombre', property: 'Name', visible: true },
        { title: 'Fecha Aplicación', property: 'ExecutedDate', visible: true, mask: MASK_DATE },
        { title: 'Fecha Ejecución', property: 'ProcessDate', visible: true, mask: MASK_DATE },
        { title: 'Empleado en Nómina', property: 'EntityEmpleado', visible: true },
        { title: 'Fecha de Nómina', property: 'AccountantDate', visible: true, mask: MASK_DATE },
        { title: 'Descripción', property: 'Description', visible: true },
        { title: 'Radicado', property: 'IDFiledNumber', visible: true },
        { title: 'Tipo', property: 'TypeName', visible: true },
        { title: 'SubTipo', property: 'SubtypeName', visible: true },
        { title: 'Estado', property: 'StateName', visible: true },
        { title: 'Visibilizar', property: 'VisibleOnEmployeePage', visible: true },
    ]

    const bodyComponent = () => {
        return (
            <div className="row">
                <div className="col-md-4">
                    <SelectTypeProcees disable={processType ? true : false} label="Tipo de Proceso" idSelector={form.processType} onChange={(e) => { setForm({ ...form, "processType": e }) }} />
                </div>
                <div className="col-md-4">
                    <label>Año</label>
                    <YearSelector tittle=" " onChange={(e) => { setForm({ ...form, "Year": e }) }} />
                </div>
                <div className="col-md-4">
                    <label>Mes desde</label>
                    <MonthConstantsEditor idSelect={form.fromMonth} onChange={(e) => { setForm({ ...form, "fromMonth": e }) }} label=" " name="" />
                </div>
                <div className="col-md-4">
                    <label>Mes hasta</label>
                    <MonthConstantsEditor idSelect={form.uptoMonth} onChange={(e) => { setForm({ ...form, "uptoMonth": e }) }} label=" " name="" />
                </div>

                <div className="col-md-4">
                    <CustomProcessTypeSeleect processType={form.processType} idSelector={form.customProcces} onChange={(e) => { setForm({ ...form, "customProcces": e }) }} />
                </div>
                <div className="col-md-4">
                    <EstadoProcesoSelector idSelector={form.state} onChange={(e) => { setForm({ ...form, "state": e }) }} />
                </div>
                <div className="col-md-4">
                    <AccountEditor label="Empleado" idAccount={form.IDAccount} onChange={(e) => { setForm({ ...form, "IDAccount": e.IDAccount }) }}></AccountEditor>
                </div>
                <div className="col-md-4">
                    <label>Número de Registros Por Pagina</label>
                    <input type="number" className="form-control" value={registers} onChange={(e) => { setRegisters(parseInt(e.target.value)) }} />
                </div>
                <div className="col-md-4 mt-4 p-2">
                    <BasicButton eventClick={getLista} icon="ri-search-line" children={"Buscar"} />
                </div>
                <div className="col-md-12">
                    <div className="col-md-12">
                        {onChange ?
                            <BasicTable
                                // headButtons={buttons()}
                                listButtons={listaBotones()}
                                head={head} body={lista}
                                rowSet={process.setBean}
                                pageTop={paginador.page}
                                next={paginador.next}
                                back={paginador.back}
                                records={paginador}
                                customRows={registers}
                            // filterModal={filter()}
                            />
                            :
                            <BasicTable
                                // headButtons={buttons()}
                                listButtons={listaBotones()}
                                head={head} body={lista}
                                rowSet={process.setBean}
                                pageTop={paginador.page}
                                next={paginador.next}
                                back={paginador.back}
                                records={paginador}
                                customRows={registers}
                            // filterModal={filter()}
                            />
                        }
                    </div>
                    {/* <BasicTable body={lista} head={head} rowSet={process.setBean} ></BasicTable> */}
                    <Modal modal={ver} updateModal={setVer} >
                        <div className="row">
                            <div className="col-md-12">
                                <DocumentViewer list={listDoc} />
                            </div>

                        </div>
                    </Modal>
                    <Modal modal={flujo} updateModal={setFlujo} eventModal={fireEcmDocumentForFlowControl}>
                        <div className="row">
                            <div className="col-md-12">
                                <SingPanelEditor idSelector={fireEcm.bean.IDSignAndApprovalPanel} onChange={(e) => { console.log(e); fireEcm.setBean({ ...fireEcm.bean, 'IDSignAndApprovalPanel': e }) }} />
                            </div>

                        </div>
                    </Modal>


                    <Modal modal={reporte} updateModal={setReporte}>
                        <div className="row">
                            <ReporteProcesosByProcces IdProcces={process.bean.IDProcess} ProccesDate={process.bean.Since} />
                        </div>
                    </Modal>
                    <Modal modal={modalNovedad.modal} updateModal={modalNovedad.setModal}>
                        <div className="row">
                            <PaymentHeaderError idProcess={process.bean.IDProcess} isOpen={isOpen} />
                        </div>
                    </Modal>
                    <Modal modal={modalcuentas} updateModal={setModalcuentas}>
                        <div className="row">
                            <PaymentAccountByProcces idProcess={process.bean.IDProcess} processDate={process.bean.Since} />
                        </div>
                    </Modal>
                    <Modal modal={modalDocs.modal} updateModal={modalDocs.setModal}>
                        <div className="row">
                            <div className="col-md-12">
                                <div className="list-group " style={{ maxHeight: "52vh", overflow: "auto" }}>
                                    {Array.isArray(process.bean?.RenderResponseJsonData?.ReportList) && process.bean?.RenderResponseJsonData?.ReportList.map((item, index) => {
                                        const docData = item.DataBeanProperties;

                                        return (
                                            <div
                                                key={index}
                                                className="list-group-item d-flex justify-content-between align-items-center"
                                            >
                                                <span style={{ width: "80%", overflow: "hidden", textWrap: "nowrap" }}>
                                                    <i className="ri-article-line fs-2 align-middle me-2 cursor"></i>
                                                    {index + 1} - {docData?.Filename ?? "Archivo sin nombre"}
                                                </span>

                                                <button
                                                    type="button"
                                                    className="btn btn-md btn-link"
                                                    style={{ textDecoration: "none" }}
                                                    onClick={() => {
                                                        if (docData?.URLLink) {
                                                            window.open(docData.URLLink, "_blank", "noopener,noreferrer");
                                                        } else {
                                                            toast.error("Link de descarga no encontrado");
                                                        }
                                                    }}
                                                >
                                                    <i className="ri-folder-download-line"></i>
                                                </button>
                                            </div>
                                        );
                                    })}
                                </div>
                            </div>
                        </div>
                    </Modal>

                    <Modal modal={modalEdit} updateModal={setModalEdit} eventModal={() => { editaItem() }}>
                        <div className="row">
                            <div className="col-md-12">
                                <label>Descripción</label>
                                <textarea className="form-control" value={process.bean.Description} onChange={(e) => { process.setBean({ ...process.bean, Description: e.target.value }) }} />
                            </div>
                            <div className="col-md-12">
                                <BasicSwitch estado={process.bean.VisibleOnEmployeePage} eventChange={(e) => { process.setBean({ ...process.bean, VisibleOnEmployeePage: e }) }} label="Visibilizar" />
                            </div>
                            {process.bean.Type === 4 &&
                                <div className="col-md-12">
                                    <SelectSubProcessType idSelector={process.bean.Subtype} onChange={(e) => { process.setBean({ ...process.bean, Subtype: e }) }} label="Subtipo de Proceso" />
                                </div>
                            }
                        </div>
                    </Modal>
                </div>

            </div>
        )
    }

    return (
        <>
            {onChange ?
                <>
                    <label>{label ?? 'Catalogo de procesos'}</label>
                    <input type="text" value={`${process.bean.Mnemonic ?? ''} - ${process.bean.Name ?? ''}`} readOnly className="form-control" onClick={() => { modalComponent.open() }} />
                    <Modal modal={modalComponent.modal} updateModal={modalComponent.setModal} eventModal={updateFather} onSubmitLabel="Seleccionar">
                        {bodyComponent()}

                    </Modal>
                </>
                :
                <BasicPage titulo="Catálogo de Procesos">
                    <>
                        {bodyComponent()}
                    </>
                </BasicPage>
            }
        </>

    )
}